var map = {
	"./00-a-preface": [
		34829,
		9,
		4829
	],
	"./00-a-preface.jsx": [
		34829,
		9,
		4829
	],
	"./00-b-on-this-release": [
		60103,
		9,
		5563
	],
	"./00-b-on-this-release.jsx": [
		60103,
		9,
		5563
	],
	"./01-GS-01": [
		86844,
		9,
		6844
	],
	"./01-GS-01.jsx": [
		86844,
		9,
		6844
	],
	"./01-GS-02": [
		88884,
		9,
		8884
	],
	"./01-GS-02.jsx": [
		88884,
		9,
		8884
	],
	"./01-GS-03": [
		64495,
		9,
		4495
	],
	"./01-GS-03.jsx": [
		64495,
		9,
		4495
	],
	"./01-GS-04": [
		8481,
		9,
		8481
	],
	"./01-GS-04.jsx": [
		8481,
		9,
		8481
	],
	"./01-GS-05": [
		89703,
		9,
		7906
	],
	"./01-GS-05.jsx": [
		89703,
		9,
		7906
	],
	"./01-GS-06": [
		25949,
		9,
		5949
	],
	"./01-GS-06.jsx": [
		25949,
		9,
		5949
	],
	"./01-GS-07": [
		5880,
		9,
		5880
	],
	"./01-GS-07.jsx": [
		5880,
		9,
		5880
	],
	"./01-GS-08": [
		42713,
		9,
		2713
	],
	"./01-GS-08.jsx": [
		42713,
		9,
		2713
	],
	"./01-GS-09": [
		27625,
		9,
		7625
	],
	"./01-GS-09.jsx": [
		27625,
		9,
		7625
	],
	"./01-GS-10": [
		42973,
		9,
		2973
	],
	"./01-GS-10.jsx": [
		42973,
		9,
		2973
	],
	"./01-overview": [
		1777,
		9,
		7729,
		1777
	],
	"./01-overview.jsx": [
		1777,
		9,
		7729,
		1777
	],
	"./02-a-installation": [
		42616,
		9,
		2616
	],
	"./02-a-installation.jsx": [
		42616,
		9,
		2616
	],
	"./02-b-help": [
		92759,
		9,
		2759
	],
	"./02-b-help.jsx": [
		92759,
		9,
		2759
	],
	"./02-c-hardware": [
		43528,
		9,
		3528
	],
	"./02-c-hardware.jsx": [
		43528,
		9,
		3528
	],
	"./02-d-opcodes": [
		3734,
		9,
		3734
	],
	"./02-d-opcodes.jsx": [
		3734,
		9,
		3734
	],
	"./02-e-print": [
		86758,
		9,
		6758
	],
	"./02-e-print.jsx": [
		86758,
		9,
		6758
	],
	"./02-overview": [
		91180,
		9,
		7729,
		1180
	],
	"./02-overview.jsx": [
		91180,
		9,
		7729,
		1180
	],
	"./03-a-initialization-and-performance-pass": [
		35390,
		9,
		5390
	],
	"./03-a-initialization-and-performance-pass.jsx": [
		35390,
		9,
		5390
	],
	"./03-b-local-and-global-variables": [
		14319,
		9,
		4319
	],
	"./03-b-local-and-global-variables.jsx": [
		14319,
		9,
		4319
	],
	"./03-c-control-structures": [
		95869,
		9,
		5869
	],
	"./03-c-control-structures.jsx": [
		95869,
		9,
		5869
	],
	"./03-d-function-tables": [
		95371,
		9,
		5371
	],
	"./03-d-function-tables.jsx": [
		95371,
		9,
		5371
	],
	"./03-e-arrays": [
		69456,
		9,
		9456
	],
	"./03-e-arrays.jsx": [
		69456,
		9,
		9456
	],
	"./03-f-live-events": [
		40530,
		9,
		530
	],
	"./03-f-live-events.jsx": [
		40530,
		9,
		530
	],
	"./03-g-user-defined-opcodes": [
		97881,
		9,
		7881
	],
	"./03-g-user-defined-opcodes.jsx": [
		97881,
		9,
		7881
	],
	"./03-h-macros": [
		66011,
		9,
		6011
	],
	"./03-h-macros.jsx": [
		66011,
		9,
		6011
	],
	"./03-i-functional-syntax": [
		47206,
		9,
		7206
	],
	"./03-i-functional-syntax.jsx": [
		47206,
		9,
		7206
	],
	"./03-overview": [
		25215,
		9,
		7729,
		5215
	],
	"./03-overview.jsx": [
		25215,
		9,
		7729,
		5215
	],
	"./04-a-additive-synthesis": [
		3582,
		9,
		3582
	],
	"./04-a-additive-synthesis.jsx": [
		3582,
		9,
		3582
	],
	"./04-b-subtractive-synthesis": [
		22118,
		9,
		2118
	],
	"./04-b-subtractive-synthesis.jsx": [
		22118,
		9,
		2118
	],
	"./04-c-amplitude-and-ring-modulation": [
		14102,
		9,
		4102
	],
	"./04-c-amplitude-and-ring-modulation.jsx": [
		14102,
		9,
		4102
	],
	"./04-d-frequency-modulation": [
		71583,
		9,
		1583
	],
	"./04-d-frequency-modulation.jsx": [
		71583,
		9,
		1583
	],
	"./04-e-waveshaping": [
		26196,
		9,
		6196
	],
	"./04-e-waveshaping.jsx": [
		26196,
		9,
		6196
	],
	"./04-f-granular-synthesis": [
		94002,
		9,
		4002
	],
	"./04-f-granular-synthesis.jsx": [
		94002,
		9,
		4002
	],
	"./04-g-physical-modelling": [
		63169,
		9,
		3169
	],
	"./04-g-physical-modelling.jsx": [
		63169,
		9,
		3169
	],
	"./04-h-scanned-synthesis": [
		83874,
		9,
		3874
	],
	"./04-h-scanned-synthesis.jsx": [
		83874,
		9,
		3874
	],
	"./04-overview": [
		59299,
		9,
		7729,
		9299
	],
	"./04-overview.jsx": [
		59299,
		9,
		7729,
		9299
	],
	"./05-a-envelopes": [
		43004,
		9,
		3004
	],
	"./05-a-envelopes.jsx": [
		43004,
		9,
		3004
	],
	"./05-b-panning-and-spatialization": [
		25935,
		9,
		5935
	],
	"./05-b-panning-and-spatialization.jsx": [
		25935,
		9,
		5935
	],
	"./05-c-filters": [
		90222,
		9,
		222
	],
	"./05-c-filters.jsx": [
		90222,
		9,
		222
	],
	"./05-d-delay-and-feedback": [
		8946,
		9,
		8946
	],
	"./05-d-delay-and-feedback.jsx": [
		8946,
		9,
		8946
	],
	"./05-e-reverberation": [
		95517,
		9,
		5517
	],
	"./05-e-reverberation.jsx": [
		95517,
		9,
		5517
	],
	"./05-f-am-rm-waveshaping": [
		21337,
		9,
		1337
	],
	"./05-f-am-rm-waveshaping.jsx": [
		21337,
		9,
		1337
	],
	"./05-g-granular-synthesis": [
		61993,
		9,
		1993
	],
	"./05-g-granular-synthesis.jsx": [
		61993,
		9,
		1993
	],
	"./05-h-convolution": [
		36445,
		9,
		6445
	],
	"./05-h-convolution.jsx": [
		36445,
		9,
		6445
	],
	"./05-i-fourier-analysis-spectral-processing": [
		70355,
		9,
		355
	],
	"./05-i-fourier-analysis-spectral-processing.jsx": [
		70355,
		9,
		355
	],
	"./05-k-ats-resynthesis": [
		92199,
		9,
		2199
	],
	"./05-k-ats-resynthesis.jsx": [
		92199,
		9,
		2199
	],
	"./05-overview": [
		30000,
		9,
		7729,
		0
	],
	"./05-overview.jsx": [
		30000,
		9,
		7729,
		0
	],
	"./06-a-record-and-play-soundfiles": [
		42294,
		9,
		2294
	],
	"./06-a-record-and-play-soundfiles.jsx": [
		42294,
		9,
		2294
	],
	"./06-b-record-and-play-buffers": [
		75318,
		9,
		5318
	],
	"./06-b-record-and-play-buffers.jsx": [
		75318,
		9,
		5318
	],
	"./06-overview": [
		83027,
		9,
		7729,
		3027
	],
	"./06-overview.jsx": [
		83027,
		9,
		7729,
		3027
	],
	"./07-a-receiving-events-by-midiin": [
		31072,
		9,
		1072
	],
	"./07-a-receiving-events-by-midiin.jsx": [
		31072,
		9,
		1072
	],
	"./07-b-triggering-instrument-instances": [
		71269,
		9,
		1269
	],
	"./07-b-triggering-instrument-instances.jsx": [
		71269,
		9,
		1269
	],
	"./07-c-working-with-controllers": [
		52407,
		9,
		2407
	],
	"./07-c-working-with-controllers.jsx": [
		52407,
		9,
		2407
	],
	"./07-d-reading-midi-files": [
		86861,
		9,
		6861
	],
	"./07-d-reading-midi-files.jsx": [
		86861,
		9,
		6861
	],
	"./07-e-midi-output": [
		57159,
		9,
		7159
	],
	"./07-e-midi-output.jsx": [
		57159,
		9,
		7159
	],
	"./07-overview": [
		21628,
		9,
		7729,
		1628
	],
	"./07-overview.jsx": [
		21628,
		9,
		7729,
		1628
	],
	"./08-a-open-sound-control": [
		48036,
		9,
		8036
	],
	"./08-a-open-sound-control.jsx": [
		48036,
		9,
		8036
	],
	"./08-b-csound-and-arduino": [
		78438,
		9,
		8438
	],
	"./08-b-csound-and-arduino.jsx": [
		78438,
		9,
		8438
	],
	"./08-c-csound-via-udp": [
		10003,
		9,
		3
	],
	"./08-c-csound-via-udp.jsx": [
		10003,
		9,
		3
	],
	"./08-overview": [
		24037,
		9,
		7729,
		4037
	],
	"./08-overview.jsx": [
		24037,
		9,
		7729,
		4037
	],
	"./09-a-csound-in-pd": [
		98514,
		9,
		8514
	],
	"./09-a-csound-in-pd.jsx": [
		98514,
		9,
		8514
	],
	"./09-b-csound-in-maxmsp": [
		83578,
		9,
		3578
	],
	"./09-b-csound-in-maxmsp.jsx": [
		83578,
		9,
		3578
	],
	"./09-c-csound-as-a-vst-plugin": [
		50949,
		9,
		949
	],
	"./09-c-csound-as-a-vst-plugin.jsx": [
		50949,
		9,
		949
	],
	"./09-overview": [
		52436,
		9,
		7729,
		2436
	],
	"./09-overview.jsx": [
		52436,
		9,
		7729,
		2436
	],
	"./10-a-csoundqt": [
		42003,
		9,
		2003
	],
	"./10-a-csoundqt.jsx": [
		42003,
		9,
		2003
	],
	"./10-b-cabbage": [
		70977,
		9,
		977
	],
	"./10-b-cabbage.jsx": [
		70977,
		9,
		977
	],
	"./10-c-blue": [
		99286,
		9,
		9286
	],
	"./10-c-blue.jsx": [
		99286,
		9,
		9286
	],
	"./10-d-winxound": [
		29891,
		9,
		9891
	],
	"./10-d-winxound.jsx": [
		29891,
		9,
		9891
	],
	"./10-e-csound-via-terminal": [
		99707,
		9,
		9707
	],
	"./10-e-csound-via-terminal.jsx": [
		99707,
		9,
		9707
	],
	"./10-f-web-based-csound": [
		71088,
		9,
		1088
	],
	"./10-f-web-based-csound.jsx": [
		71088,
		9,
		1088
	],
	"./10-overview": [
		19000,
		9,
		7729,
		9000
	],
	"./10-overview.jsx": [
		19000,
		9,
		7729,
		9000
	],
	"./11-a-analysis": [
		72159,
		9,
		2159
	],
	"./11-a-analysis.jsx": [
		72159,
		9,
		2159
	],
	"./11-b-file-info-and-conversion": [
		87176,
		9,
		7176
	],
	"./11-b-file-info-and-conversion.jsx": [
		87176,
		9,
		7176
	],
	"./11-c-miscellaneous": [
		87728,
		9,
		7728
	],
	"./11-c-miscellaneous.jsx": [
		87728,
		9,
		7728
	],
	"./11-overview": [
		47579,
		9,
		7729,
		7579
	],
	"./11-overview.jsx": [
		47579,
		9,
		7729,
		7579
	],
	"./12-a-the-csound-api": [
		44615,
		9,
		4615
	],
	"./12-a-the-csound-api.jsx": [
		44615,
		9,
		4615
	],
	"./12-b-python-and-csound": [
		48811,
		9,
		8811
	],
	"./12-b-python-and-csound.jsx": [
		48811,
		9,
		8811
	],
	"./12-c-lua-and-csound": [
		85976,
		9,
		5976
	],
	"./12-c-lua-and-csound.jsx": [
		85976,
		9,
		5976
	],
	"./12-d-csound-in-ios": [
		33509,
		9,
		3509
	],
	"./12-d-csound-in-ios.jsx": [
		33509,
		9,
		3509
	],
	"./12-e-csound-on-android": [
		59703,
		9,
		9703
	],
	"./12-e-csound-on-android.jsx": [
		59703,
		9,
		9703
	],
	"./12-f-csound-and-haskell": [
		78942,
		9,
		8942
	],
	"./12-f-csound-and-haskell.jsx": [
		78942,
		9,
		8942
	],
	"./12-g-csound-in-html-and-javascript": [
		75139,
		9,
		5139
	],
	"./12-g-csound-in-html-and-javascript.jsx": [
		75139,
		9,
		5139
	],
	"./12-overview": [
		48411,
		9,
		7729,
		8411
	],
	"./12-overview.jsx": [
		48411,
		9,
		7729,
		8411
	],
	"./13-a-developing-plugin-opcodes": [
		90728,
		9,
		728
	],
	"./13-a-developing-plugin-opcodes.jsx": [
		90728,
		9,
		728
	],
	"./13-overview": [
		61890,
		9,
		7729,
		1890
	],
	"./13-overview.jsx": [
		61890,
		9,
		7729,
		1890
	],
	"./14-a-opcode-guide": [
		63782,
		9,
		3782
	],
	"./14-a-opcode-guide.jsx": [
		63782,
		9,
		3782
	],
	"./14-b-methods-of-writing-csound-scores": [
		99132,
		9,
		9132
	],
	"./14-b-methods-of-writing-csound-scores.jsx": [
		99132,
		9,
		9132
	],
	"./14-c-amplitude-and-pitch-tracking": [
		27721,
		9,
		7721
	],
	"./14-c-amplitude-and-pitch-tracking.jsx": [
		27721,
		9,
		7721
	],
	"./14-d-python-in-csoundqt": [
		40213,
		9,
		213
	],
	"./14-d-python-in-csoundqt.jsx": [
		40213,
		9,
		213
	],
	"./14-e-glossary": [
		71506,
		9,
		1506
	],
	"./14-e-glossary.jsx": [
		71506,
		9,
		1506
	],
	"./14-f-links": [
		74647,
		9,
		4647
	],
	"./14-f-links.jsx": [
		74647,
		9,
		4647
	],
	"./14-g-credits": [
		10119,
		9,
		119
	],
	"./14-g-credits.jsx": [
		10119,
		9,
		119
	],
	"./14-overview": [
		19295,
		9,
		7729,
		9295
	],
	"./14-overview.jsx": [
		19295,
		9,
		7729,
		9295
	],
	"./15-a-digital-audio": [
		34737,
		9,
		4737
	],
	"./15-a-digital-audio.jsx": [
		34737,
		9,
		4737
	],
	"./15-b-pitch-and-frequency": [
		54493,
		9,
		4493
	],
	"./15-b-pitch-and-frequency.jsx": [
		54493,
		9,
		4493
	],
	"./15-c-intensities": [
		26756,
		9,
		6756
	],
	"./15-c-intensities.jsx": [
		26756,
		9,
		6756
	],
	"./15-d-random": [
		83426,
		9,
		3426
	],
	"./15-d-random.jsx": [
		83426,
		9,
		3426
	],
	"./15-overview": [
		79774,
		9,
		7729,
		9774
	],
	"./15-overview.jsx": [
		79774,
		9,
		7729,
		9774
	],
	"./interactive-demo": [
		39535,
		9
	],
	"./interactive-demo.jsx": [
		39535,
		9
	],
	"./routes": [
		35386,
		3
	],
	"./routes.json": [
		35386,
		3
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 67972;
module.exports = webpackAsyncContext;